import {
  REQUEST_USER,
  USER_LOADED,
  COGNITO_DATA_LOADED,
  GET_USER_COUNTRY_NAME_SUCCESS,
  GET_TOKEN_SUCCESS,
} from "./UserActions";

/**
 * User reducer to manage user's state globaly in app
 * @param {*} state user state
 * @param {*} action user action
 */
export function userReducer(
  state = {
    actionsloading: false,
    cognito_data: {},
    user: {},
    error: null,
  },
  action
) {
  switch (action.type) {
    case REQUEST_USER:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case COGNITO_DATA_LOADED:
      return {
        ...state,
        cognito_data: action.payload.cognito_data,
      };
    case USER_LOADED:
      return {
        ...state,
        user: action.payload.user,
        actionsloading: false,
      };
    case GET_USER_COUNTRY_NAME_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          country_name: action.payload.country_name,
        },
        actionsloading: false,
      };
    case GET_TOKEN_SUCCESS:
      return {
        ...state,
        cognito_data: {
          ...state.cognito_data,
          token: action.payload.token,
        },
      };
    default:
      return state;
  }
}
